/*
 * TODO: enable typscript
 * https://app.asana.com/0/1200062349227021/1199917794572413/f
 * import { Options, EmbedOptions, TechOptions } from './analytics.types'
 */
import { getAnalytics } from './analytics.helpers'

export default {
  /* (options: Options) */
  getCampaigns: options => getAnalytics('campaigns', options),
  getDownloads: options => getAnalytics('downloads', options),
  getDMA: options => getAnalytics('dma', options),
  getOverlap: options => getAnalytics('overlap/comparison', options),
  getEpisodes: options => getAnalytics('episodes', options),
  getListeners: options => getAnalytics('listeners', options),
  getLocation: options => getAnalytics('location', options),
  getPodcasts: options => getAnalytics('podcasts', options),
  getTimeOfWeek: options => getAnalytics('time_of_week', options),
  /* (options: EmbedOptions) */
  getEmbed: options => getAnalytics('embed', options),
  /* (options: TechOptions) */
  getTech: options => getAnalytics('technology', options)
}
